import React from 'react';
import { Box, Typography } from '@mui/material';
import { themeColors } from 'toolkit/styles/colors';
import { timeFormatter } from '@act/shared/utilities';

export const SubheaderAndDescription: React.FC<{
  subheader: string;
  description: React.ReactNode;
}> = ({ subheader, description }) => {
  const descriptionIsString = typeof description === 'string';

  return (
    <Box display="flex" gap="8px">
      <Typography
        sx={{ color: themeColors.onSurfaceVariant }}
        variant="labelMedium"
      >
        {subheader}
      </Typography>
      {descriptionIsString ? (
        <Typography variant="bodyMedium" component="div">
          {description}
        </Typography>
      ) : (
        description
      )}
    </Box>
  );
};

export const HistoryEntryDescription: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <Typography variant="bodyMedium" component="div">
      {children}
    </Typography>
  );
};

export const HistoryEntrySubheader: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <Typography
      sx={{ color: themeColors.onSurfaceVariant }}
      variant="labelMedium"
      component="div"
    >
      {children}
    </Typography>
  );
};

export const getHistoryEntryDateLine = (
  dateMillis: number,
  creatorName: string
): string => {
  const dateOf = timeFormatter.epochToHumanReadableDate({
    date: dateMillis,
  });

  return `${dateOf} · ${creatorName || 'Unknown'}`;
};
